const SESSION_KEY = 'account_setup_demo';
const PREFERENCE_PREFIX = 'account_setup_demo_preference:';

interface DemoSession { actorId: string; startTour: boolean; }
export function getDemoSession(): DemoSession | null {
  try { return JSON.parse(sessionStorage.getItem(SESSION_KEY) ?? 'null'); } catch { return null; }
}
export const isDemoSession = (): boolean => Boolean(getDemoSession());
export function beginDemoSession(actorId: string, startTour: boolean): void {
  sessionStorage.setItem(SESSION_KEY, JSON.stringify({ actorId, startTour }));
}
export function openDemoTab(startTour = false): void {
  window.open(`/demo-entry${startTour ? '?tour=1' : ''}`, '_blank', 'noopener,noreferrer');
}
export function exitDemoSession(): void {
  sessionStorage.removeItem(SESSION_KEY);
  Object.keys(sessionStorage).filter(key => key.startsWith(PREFERENCE_PREFIX)).forEach(key => sessionStorage.removeItem(key));
  window.location.replace('/setup');
}
export function consumeDemoTourIntent(): void {
  const session = getDemoSession();
  if (session) beginDemoSession(session.actorId, false);
}
export function getDemoPreference(key: string): string | null {
  return sessionStorage.getItem(`${PREFERENCE_PREFIX}${key}`);
}
export function setDemoPreference(key: string, value: string | null): void {
  if (value === null) sessionStorage.removeItem(`${PREFERENCE_PREFIX}${key}`);
  else sessionStorage.setItem(`${PREFERENCE_PREFIX}${key}`, value);
}
export const getDemoRestaurantId = () => getDemoPreference('selected_restaurant_id');
export const setDemoRestaurantId = (id: string) => setDemoPreference('selected_restaurant_id', id);
